import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {CardBody, CardHeader, Table, Button, ButtonGroup} from 'reactstrap'
import {Query} from 'react-apollo'
import {GET_COMPANIES} from './graphql'
import queryString from 'query-string'
import ReactPaginate from 'react-paginate'
import {UnmountClosed} from 'react-collapse'
import BlockWithLoader from '../Support/BlockWithLoader'
import CompanyForm from './CompanyForm'
import {getUserPermissions} from '../../utils/userPermissions'
import CompanyRow from './CompanyRow'

const propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

class Companies extends Component {
  constructor() {
    super()
    this.state = {
      formIsOpen: false,
      editData: {}
    }

    this.formToggleFunction = this.formToggleFunction.bind(this)
  }

  formToggleFunction({data = {}} = {}) {
    this.setState({formIsOpen: !this.state.formIsOpen, editData: data})
  }

  render() {
    const parsedQuery = queryString.parse(this.props.location.search)

    return (
      <Query query={GET_COMPANIES} variables={{page: Number(parsedQuery.page) || 1, size: 10}}
        fetchPolicy='network-only' notifyOnNetworkStatusChange>
        {({data: {companies}, loading, error}) => {
          if (error) return <div>An unexpected error occurred</div>

          return (
            <BlockWithLoader loading={loading} renderChildren={true}>
              <UnmountClosed isOpened={this.state.formIsOpen}>
                <CardHeader>{this.state.editData.id ? 'Edit company' : 'Add new company'}</CardHeader>
                <CompanyForm
                  afterSubmit={this.formToggleFunction}
                  onClose={this.formToggleFunction}
                  company={this.state.editData}
                />
              </UnmountClosed>
              <CardHeader>
                <b>Companies</b>
                {!this.state.formIsOpen && <ButtonGroup size='sm' className="float-right">
                  <Button color="success" onClick={()=> this.props.history.push('/companies/main')}>Main company</Button>
                  {getUserPermissions('core.companies.create') &&
                  <Button color="primary" onClick={this.formToggleFunction}><i className="fa fa-plus"/>{' '}Add new company</Button>}
                </ButtonGroup>}
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead>
                    <tr>
                      <th style={{width: '60px'}}/>
                      <th scope="col">name</th>
                      <th scope="col">roles</th>
                      <th scope="col">city</th>
                      <th scope="col">nip</th>
                      <th scope="col">phone</th>
                      <th scope="col">email</th>
                      <th scope="col" className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading && companies.list.map((company, idx) =>
                      <CompanyRow key={idx} company={company}
                        history={this.props.history}
                        formToggleFunction={this.formToggleFunction}
                        fomIsOpen={this.state.formIsOpen}
                      />
                    )}
                  </tbody>
                </Table>
              </CardBody>

              {!loading && companies.metadata.total_pages > 1 &&
              <ReactPaginate
                forcePage={companies.metadata.current_page - 1}
                pageCount={companies.metadata.total_pages}
                onPageChange={({selected}) => this.props.history.push(`/companies?page=${selected + 1}`)}
                containerClassName={'pagination justify-content-center'}
                activeClassName={'active'}
              />}
            </BlockWithLoader>
          )
        }
        }
      </Query>
    )
  }
}

Companies.propTypes = propTypes

export default Companies



// WEBPACK FOOTER //
// ./src/components/Companies/Companies.js